import api from './api';

// File Virtuelle Magasin — API CRM authentifiée (onglet de gestion).
const fileMagasinApi = {
  // File d'attente
  getQueue: (date) => api.get('/file-magasin/queue', { params: date ? { date } : {} }),
  setStatut: (id, statut) => api.put(`/file-magasin/queue/${id}`, { statut }),
  deleteEntry: (id) => api.delete(`/file-magasin/queue/${id}`),

  // Vendeurs magasin
  getVendeurs: () => api.get('/file-magasin/vendeurs'),
  createVendeur: (data) => api.post('/file-magasin/vendeurs', data),
  updateVendeur: (id, data) => api.put(`/file-magasin/vendeurs/${id}`, data),
  deleteVendeur: (id) => api.delete(`/file-magasin/vendeurs/${id}`),

  // Motifs de visite
  getMotifs: () => api.get('/file-magasin/motifs'),
  createMotif: (data) => api.post('/file-magasin/motifs', data),
  updateMotif: (id, data) => api.put(`/file-magasin/motifs/${id}`, data),
  deleteMotif: (id) => api.delete(`/file-magasin/motifs/${id}`),

  // Réglages borne (titre / logo / motif obligatoire)
  getConfig: () => api.get('/file-magasin/config'),
  updateConfig: (data) => api.put('/file-magasin/config', data),
};

export default fileMagasinApi;
